// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customInterIceptors } from '../../../../../lib/AxiosProvider';

import { error, success } from '../../../../ui-elements/response-popup';

const API = customInterIceptors();

export const addSport = createAsyncThunk('tournament/addSport', async (payload, { dispatch }) => {
  const response = await API.post(`tournament/sport/create`, payload);
  if (response.status == 201) {
    error('Sport title already exist');
    return response.data;
  } else if (response.status == 200) {
    success('Tournament sport created successfully');
    const sportList = await dispatch(getSportList());
    dispatch(setSportList(sportList.payload));
    return response.data;
  }
});

export const updateSport = createAsyncThunk(
  'tournament/updateSport',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/sport/update/`, payload);
      if (response.status == 201) {
        error('Sport title already exist');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament sport updated successfully');
        const sportList = await dispatch(getSportList());
        dispatch(setSportList(sportList.payload));
        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const getSportList = createAsyncThunk(
  'tournament/getSportList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/sport/getlist`);
    dispatch(setSportList(response.data));
    return response.data;
  }
);

export const deleteSport = createAsyncThunk('tournament/deleteSport', async (id, { dispatch }) => {
  const response = await API.delete(`tournament/sport/delete/${id}`);
  return response.data;
});

export const addEvent = createAsyncThunk('tournament/addEvent', async (payload, { dispatch }) => {
  const response = await API.post(`tournament/event/create`, payload);
  if (response.status == 201) {
    error('Event title already exist');
    return response.data;
  } else if (response.status == 200) {
    success('Tournament event created successfully');
  }
  return response;
});

export const updateEvent = createAsyncThunk(
  'tournament/updateEvent',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/event/update/`, payload);
      if (response.status == 201) {
        error('Event title already exist');
        return response;
      } else if (response.status == 200) {
        success('Tournament event updated successfully');
        return response;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const getEventList = createAsyncThunk(
  'tournament/getEventList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/event/getlist/`, { params: payload });
    dispatch(setEventList(response.data));
    return response.data;
  }
);

export const getEventListWithoutAuth = createAsyncThunk(
  'tournament/getEventListWithoutAuth',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/event/getlistWithoutAuth/`, { params: payload });
    dispatch(setEventList(response.data));
    return response.data;
  }
);

export const deleteEvent = createAsyncThunk('tournament/deleteEvent', async (id, { dispatch }) => {
  const response = await API.delete(`tournament/event/delete/${id}`);
  return response.data;
});

export const addDivision = createAsyncThunk(
  'tournament/addDivision',
  async (payload, { dispatch }) => {
    const response = await API.post(`tournament/division/create`, payload);
    if (response.status == 201) {
      error('Division title already exist');
      return response.data;
    } else if (response.status == 200) {
      success('Tournament division created successfully');
      return response;
    }
  }
);

export const getDivisionList = createAsyncThunk(
  'tournament/getDivisionList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/division/getlist`, {
      params: payload
    });
    dispatch(setDivisionList(response.data));
    return response.data;
  }
);

export const getDivisionListWithoutAuth = createAsyncThunk(
  'tournament/getDivisionListWithoutAuth',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/division/getlistWithoutAuth`, {
      params: payload
    });
    dispatch(setDivisionList(response.data));
    return response.data;
  }
);

export const updateDivision = createAsyncThunk(
  'tournament/updateDivision',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/division/update/`, payload);
      if (response.status == 201) {
        error('Division title already exist');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament division updated successfully');
        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const mergeDivision = createAsyncThunk(
  'tournament/mergeDivision',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/division/merge/`, payload);
      if (response.status == 201) {
        error('Division title already exist');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament division merged successfully');

        dispatch(getTournamentInfo(payload?.tournamentId));

        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const unmergeDivision = createAsyncThunk(
  'tournament/unmergeDivision',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/division/unmerge/`, payload);
      if (response.status == 201) {
        error("Tournament doesn't exist");
        return response.data;
      } else if (response.status == 202) {
        error('No division to unmerge');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament division unmerged successfully');

        dispatch(getTournamentInfo(payload?.tournamentId));

        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const masterReset = createAsyncThunk(
  'tournament/masterReset',
  async (payload, { dispatch }) => {
    try {
      const response = await API.post(`tournament/division/master-reset/`, payload);
      if (response.status == 201) {
        error("Tournament doesn't exist");
        return response.data;
      } else if (response.status == 202) {
        error('No division to unmerge');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament divisions have been reset successfully');

        dispatch(getTournamentInfo(payload?.tournamentId));

        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const deleteDivision = createAsyncThunk(
  'tournament/deleteDivision',
  async (id, { dispatch }) => {
    const response = await API.delete(`tournament/division/delete/${id}`);
    return response.data;
  }
);

export const getDivisionbyId = createAsyncThunk(
  'tournament/getDivisionbyId',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/division/getbyid?id=${payload}`);
    dispatch(setDivisionList(response.data));
    return response.data;
  }
);

export const getDivisionbyEventId = createAsyncThunk(
  'tournament/getDivisionbyEventId',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/create/getdivisionbyevent/?id=${payload}`);
    dispatch(setDivisionList(response.data));
    return response.data;
  }
);

export const createTournament = createAsyncThunk(
  'tournament/createTournament',
  async (payload, { dispatch }) => {
    const response = await API.post('tournament/createTournament', payload);
    return response.data;
  }
);

export const updateTournament = createAsyncThunk(
  'tournament/updateTournament',
  async ({ _id, tournamentForm }, { dispatch }) => {
    const response = await API.put(`tournament/updateTournament/${_id}`, tournamentForm);
    const result = await dispatch(getTournamentList());
    return response.data;
  }
);

export const updateTournamentPublicDisplayStatus = createAsyncThunk(
  'tournament/updateTournamentPublicDisplayStatus',
  async ({ _id, status }, { dispatch }) => {
    console.log('updateTournamentPublicDisplayStatus', status);
    const response = await API.put(`tournament/updateTournamentPublicDisplayStatus/${_id}`, {
      isPublicDisplay: status
    });
    // const result = await dispatch(getTournamentList());
    if (response.status == 200) {
      success('Updated public display status successfully');
      await dispatch(getTournamentInfo(_id));
    } else {
      error('Update failed');
    }
    return response.data;
  }
);

export const getTournamentList = createAsyncThunk(
  'tournament/getTournamentList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/getTournamentList`, {
      params: payload
    });
    dispatch(setTournamentList(response.data));
    return response;
  }
);

export const getAllTournamentEvent = createAsyncThunk(
  'tournament/getTournamentList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/all-tournament-events`);
    console.log(response, "response");
    if (response?.data?.success) {
      dispatch(setAllTournament(response?.data?.data))
      return response;
    }
  }
);

export const getTournamentInfo = createAsyncThunk(
  'tournament/getTournamentInfo',
  async (id, { dispatch }) => {
    const response = await API.get(`tournament/info/${id}`);
    dispatch(setTournamentInfo(response.data));
    return response;
  }
);

export const deleteTournament = createAsyncThunk(
  'tournament/deleteTournament',
  async (id, { dispatch }) => {
    const response = await API.delete(`tournament/${id}`);
    if (response.status == 200) {
      await dispatch(getTournamentList());
    }
    dispatch(setTournamentInfo({}));
    return response;
  }
);

export const updatePayment = createAsyncThunk(
  'tournament/updatePayment',
  async ({ id, payload }, { dispatch }) => {
    try {
      const { data } = await API.put(`/tournament/payment/${id}`, payload);
      if (data) {
        dispatch(getTournamentInfo(id));
        success('Payment done successfully');
      }
    } catch (error) {}
  }
);

export const addUpdateGuests = createAsyncThunk(
  'event/addUpdateGuests',
  async ({ _id, guestData }, { dispatch }) => {
    const response = await API.put(`tournament/add-update-guest/${_id}`, { guestData });
    dispatch(getTournamentInfo(_id));
    return response.data;
  }
);

export const updateGuestData = createAsyncThunk(
  'event/updateGuestData',
  async ({ guestId, guestData }, { dispatch }) => {
    const response = await API.put(`tournament/update-guest-data/${guestId}`, { guestData });
    return response.data;
  }
);

export const deleteGuests = createAsyncThunk(
  'event/deleteGuests',
  async ({ tournamentId, guestIds }, { dispatch }) => {
    const response = await API.delete(`tournament/delete-guests/${tournamentId}`, {
      params: { guestIds }
    });

    console.log(response);

    if (response.status == 200) {
      success('Removed successfully');
      await dispatch(getTournamentInfo(tournamentId));
    } else {
      error('Remove failed');
    }

    return response.data;
  }
);

export const sendMailForWaiverSign = (payload) =>
  API.post('/tournament/sendMailForWaiverSign', payload);

export const saveBracket = createAsyncThunk(
  'event/saveBracket',
  async ({ _id, payload }, { dispatch }) => {
    const response = await API.put(`tournament/update-bracket/${_id}`, { payload });
    if (response.status == 200) {
      success('Bracket saved successfully');
    } else {
      error('Save failed');
      console.log(response);
    }
    return response.data;
  }
);

export const updateDigitalScore = createAsyncThunk(
  'event/updateDigitalScore',
  async ({ _id, payload }, { dispatch }) => {
    const response = await API.put(`tournament/update-digital-score/${_id}`, { payload });
    await dispatch(getTournamentInfo(_id));
    return response.data;
  }
);

export const addTemplate = createAsyncThunk(
  'tournament/addTemplate',
  async (payload, { dispatch }) => {
    const response = await API.post(`tournament/point-template/`, payload);
    if (response.status == 201) {
      error('Template title already exist');
      return response.data;
    } else if (response.status == 200) {
      success('Tournament point-template created successfully');
      dispatch(getTemplateList());
      return response;
    }
  }
);

export const getTemplateList = createAsyncThunk(
  'tournament/getTemplateList',
  async (payload, { dispatch }) => {
    const response = await API.get(`tournament/point-template/`, {
      params: payload
    });
    dispatch(setTemplateList(response.data));
    return response.data;
  }
);

export const updateTemplate = createAsyncThunk(
  'tournament/updateTemplate',
  async (payload, { dispatch }) => {
    try {
      const response = await API.put(`tournament/point-template/`, payload);
      if (response.status == 201) {
        error('Template title already exist');
        return response.data;
      } else if (response.status == 200) {
        success('Tournament point template updated successfully');
        dispatch(getTemplateList());
        return response.data;
      }
    } catch (err) {
      console.log(err);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  'tournament/deleteTemplate',
  async (id, { dispatch }) => {
    const response = await API.delete(`tournament/point-template/delete/${id}`);
    dispatch(getTemplateList());
    return response.data;
  }
);

export const tournamentSlice = createSlice({
  name: 'tournament',
  initialState: {
    allTournament: [],
    tournamentList: [],
    tournamentInfo: {},
    sportList: [],
    eventList: [],
    pointTemplateList: [],
    divisionList: [],
    brackets: {
      roundOrder: [],
      selectedAthleteCard: {}
    },
    result: []
  },
  reducers: {
    setAllTournament: (state, action) => {
      state.allTournament = action.payload;
    },
    setTournamentList: (state, action) => {
      state.tournamentList = action.payload;
    },
    setSportList: (state, action) => {
      state.sportList = action.payload;
    },
    setEventList: (state, action) => {
      state.eventList = action.payload;
    },
    setTemplateList: (state, action) => {
      state.pointTemplateList = action.payload;
    },
    setTournamentResult: (state, action) => {
      state.result = action.payload;
    },
    setDivisionList: (state, action) => {
      state.divisionList = action.payload;
    },
    setTournamentInfo: (state, action) => {
      state.tournamentInfo = action.payload;
    },
    setBracketRoundsOrder: (state, action) => {
      state.brackets.roundOrder = action.payload;
    },
    setSelectedAthleteCard: (state, action) => {
      state.brackets.selectedAthleteCard = action.payload;
    }
  }
});

export const {
  setTournamentList,
  setAllTournament,
  setSportList,
  setEventList,
  setTemplateList,
  setTournamentResult,
  setDivisionList,
  setTournamentInfo,
  setBracketRoundsOrder,
  setSelectedAthleteCard
} = tournamentSlice.actions;

export default tournamentSlice.reducer;
